let backendHost;

const hostname = window && window.location && window.location.hostname;

if (hostname === 'localhost') {
    backendHost = 'http://localhost:8080';
} else if (hostname === 'order.symbev.thewebpeople.ca') {
    backendHost = 'https://order.symbev.thewebpeople.ca';
} else {
    backendHost = 'https://order.symbevbrands.com';
}

export const API_ROOT = `${backendHost}/api`;